// extracted by mini-css-extract-plugin
module.exports = {"centered":"ChangePassword_centered__uloMe","centeredText":"ChangePassword_centeredText__2jY_t"};